module.exports = __webpack_public_path__ + "static/img/today-search.428d27e1.png";